import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { mergeStyles } from 'react-select';
import AsyncReactSelect from 'react-select/async';
import DropdownIndicator from './dropdown-indicator';
import LoadingIndicator from './loading-indicator';
import { useSelectStyles } from './select-styles';

const AsyncSelect = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const { error, components, styles, ...otherProps } = props;

  return (
    <AsyncReactSelect
      ref={ref}
      placeholder={t('field.select_an_option')}
      menuShouldScrollIntoView
      menuPlacement="auto"
      {...otherProps}
      components={{ DropdownIndicator, IndicatorSeparator: null, LoadingIndicator, ...components }}
      styles={mergeStyles(useSelectStyles(error), styles)}
    />
  );
});

AsyncSelect.propTypes = {
  components: PropTypes.object,
  styles: PropTypes.object,
  error: PropTypes.bool,
};
AsyncSelect.defaultProps = {
  components: undefined,
  styles: undefined,
  error: undefined,
};

export default AsyncSelect;
